import { atom } from 'recoil';

export const trucksListState = atom({
  key: 'trucksListState',
  default: [],
});
